import { Directive, Input, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[appTabContent]',
  standalone: true,
})
export class TabContentDirective {
  @Input({ alias: 'appTabContent', required: true }) tabId!: string;
  readonly template = inject<TemplateRef<unknown>>(TemplateRef);
}
